import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import { Fragment, useState, useRef } from 'react';
import { useLocationState } from '../context/location';
import { submitClientRequest } from '../helpers/clientRequest';
import Input from '../components/Input';
import Textarea from '../components/Textarea';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Intro from '../components/Intro';
import Splitter from '../components/Splitter';
import MortgageCalculator from '../components/mortgage/MortgageCalculator';
import MortgageSteps from '../components/mortgage/MortgageSteps';
import MortgageCarousel from '../components/mortgage/MortgageCarousel';
import MortgageFAQ from '../components/mortgage/MortgageFAQ';
import steps from '../data/steps.json';
import FormAgreement from '../components/FormAgreement';

const Modal = dynamic(() => import('../components/Modal'));

const MortgagePage = () => {
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: '/mortgage',
        whatComponent: 'MortgagePage',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <Fragment>
      <NextSeo
        title="Услуги по оформлению ипотеки, расчёт"
        description="Услуги по оформлению ипотеки агентства недвижимости «ЛЕНДЛОРД» в Ростовской области: расчёт, оформление, оставить заявку."
        openGraph={{
          url: 'https://landlord.ru',
          type: 'website',
          title: 'Услуги по оформлению ипотеки, расчёт',
          description:
            'Услуги по оформлению ипотеки агентства недвижимости «ЛЕНДЛОРД» в Ростовской области: расчёт, оформление, оставить заявку.',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <Header />
      <main>
        <Intro
          title="Одна заявка прямиком во все банки"
          description="Найдем решение в самых сложных ситуациях, даже если ваша кредитная история не идеальна. Расчет за 1 день, консультация бесплатная"
          image="/images/stock-6.webp"
          button="Отправить заявку"
          phone="+7 800 222 81 08"
          phoneURI="tel:+79054307542"
          onClick={() => setIsModalVisible(true)}
        />
        <Modal
          title="Заявка на консультацию"
          button={!isSubmited && 'Отправить'}
          buttonDisabled={!agreeWithPolicy}
          action={handleFormSubmit}
          visibility={isModalVisible}
          onClose={() => setIsModalVisible(false)}
        >
          {isSubmited ? (
            <Fragment>
              <div style={{ marginBottom: 18 }}>Спасибо за заявку. Мы скоро с Вами свяжемся!</div>
              <img
                src="/images/thumbUp.png"
                alt=""
                style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
              />
            </Fragment>
          ) : (
            <Fragment>
              <div style={{ marginBottom: 18 }}>
                Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки,
                поможем оформить ипотеку при необходимости!
              </div>
              <Input
                title="Имя"
                inputs={[
                  {
                    placeholder: 'Василий Петрович',
                    value: clientName,
                    type: 'text'
                  }
                ]}
                isWrappedStyle
                ref={clientNameId}
                onChange={(v) => setClientName(v[0])}
              />
              <Input
                title="Телефон"
                inputs={[
                  {
                    placeholder: locationState.phone,
                    value: clientPhone,
                    mask: 'phone',
                    type: 'tel'
                  }
                ]}
                isWrappedStyle
                ref={clientPhoneId}
                onChange={(v) => setClientPhone(v[0])}
              />
              <Textarea
                title="Коммментарий"
                placeholder="Например, «Помогите с подбором ипотеки, есть 300 000 рублей первоначального взноса»"
                autoHeight
                isWrappedStyle
                onChange={(v) => setClientComment(v)}
              />
              <FormAgreement onChange={setAgreeWithPolicy} />
            </Fragment>
          )}
        </Modal>
        <MortgageCalculator />
        <MortgageCarousel />
        <MortgageSteps steps={steps} />
        <MortgageFAQ />
        <Splitter
          title="Нужна консультация?"
          subtitle="Укажите свой номер телефона и мы ответим Вам на все вопросы"
        />
      </main>
      <Footer seo="Ипотека в Ростове-на-Дону, Азове, Новочеркасске и Батайске" />
    </Fragment>
  );
};

export default MortgagePage;
